export default "__VITE_ASSET__B3FqEa8e__"